<template>
  <el-form>
    <el-tabs
      class="mb-3"
      value="0"
      tab-position="left"
      @tab-click="resetCustomerUser"
    >
      <el-tab-pane
        class="pl-3"
        label="Customer"
      >
        <el-form-item
          label="Account"
          required
        >
          <el-select
            v-model="event.account"
            class="w-100"
            clearable
            filterable
            remote
            value-key="id"
            :remote-method="searchAccounts"
            :loading="isSearchingAccounts"
          >
            <el-option
              v-for="account in accounts"
              :key="account.id"
              :label="account.label"
              :value="account"
            />
          </el-select>
        </el-form-item>

        <el-form-item
          class="m-0"
          label="Team"
        >
          <el-select
            v-model="event.team"
            class="w-100"
            clearable
            value-key="id"
            :disabled="!event.account"
          >
            <el-option
              v-for="team in teams"
              :key="team.id"
              :label="team.label"
              :value="team"
            />
          </el-select>
        </el-form-item>
      </el-tab-pane>

      <el-tab-pane
        class="pl-3"
        label="User"
      >
        <el-form-item
          class="m-0"
          label="Profile"
          required
        >
          <el-select
            v-model="event.profile"
            class="w-100"
            clearable
            filterable
            remote
            value-key="id"
            :remote-method="searchProfiles"
            :loading="isSearchingProfiles"
          >
            <el-option
              v-for="profile in profiles"
              :key="profile.id"
              :value="profile"
            >
              {{ profile.name }} <small class="text-muted pl-1">{{ profile.email }}</small>
            </el-option>
          </el-select>
        </el-form-item>
      </el-tab-pane>
    </el-tabs>

    <el-form-item label="Note">
      <el-input
        v-model="note.content"
        type="textarea"
      />
    </el-form-item>

    <el-form-item label="Attachments">
      <div class="clearfix" />

      <FileUpload
        drag
        multiple
      />
    </el-form-item>
  </el-form>
</template>

<script>
import FileUpload from '@/components/FileUpload'
import { TYPE_ALLOCATE } from '@/plugins/sdk/resources/Asset/Event'

export default {
  components: {
    FileUpload
  },
  props: {
    asset: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isSearchingAccounts: false,
      isSearchingProfiles: false,
      accounts: [],
      profiles: [],
      event: Object.assign(new this.$sdk.asset_event(), {
        type: TYPE_ALLOCATE
      }),
      note: new this.$sdk.note()
    }
  },
  computed: {
    teams () {
      return this.event.account ? this.event.account.teams : []
    }
  },
  mounted () {
    this
      .event
      .notes
      .push(this.note)

    this
      .asset
      .events
      .push(this.event)
  },
  methods: {
    resetCustomerUser () {
      this.event.$fields.account.reset()
      this.event.$fields.team.reset()
      this.event.$fields.profile.reset()

      this.accounts = []
      this.profiles = []
    },
    async searchAccounts (query) {
      this.isSearchingAccounts = true

      try {
        this.accounts = await this
          .$sdk
          .search(query, this.$sdk.account, request => {
            request.include = [ 'account.teams' ]
          })
      } finally {
        this.isSearchingAccounts = false
      }
    },
    async searchProfiles (query) {
      this.isSearchingProfiles = true

      try {
        this.profiles = await this
          .$sdk
          .search(query, this.$sdk.profile)
      } finally {
        this.isSearchingProfiles = false
      }
    }
  }
}
</script>
